import React, { useEffect, useState } from 'react';
import { isProd, isRTL } from '../services/utils/general';
import { LogService } from '../services/LogService';

interface IAppContext {
  direction: string;
  setDirection: React.Dispatch<React.SetStateAction<string>>;
  appLoading: boolean;
  setAppLoading: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AppContext = React.createContext<IAppContext>({
  direction: 'ltr',
  setDirection: () => {},
  appLoading: true,
  setAppLoading: () => {},
  showModal: false,
  setShowModal: () => {},
});

interface Props {
  children: React.ReactNode;
}

const useAppContext = (): any => {
  const [direction, setDirection] = useState('ltr');
  const [appLoading, setAppLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  return {
    direction,
    setDirection,
    appLoading,
    setAppLoading,
    showModal,
    setShowModal,
  };
};

export const AppContextProvider: React.FC<Props> = ({ children }) => {
  const appContextValue = useAppContext();
  useEffect(() => {
    if (isProd()) {
      const logService = new LogService();
      logService.init();
    }
  }, []);

  const dir = isRTL(appContextValue.direction) ? 'rtl' : 'ltr';

  return (
    <AppContext.Provider value={appContextValue}>
      <div style={{ direction: dir }} dir={dir}>
        {children}
      </div>
    </AppContext.Provider>
  );
};
